import { Input } from './Input';

export type { TypeInputProps } from './types';
export default Input;
